export const UNTAGGED_ID = "untagged";

export const TRACK_EVENT_NAME = "Tags filter";
